import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Provider } from 'react-redux';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import theme from './styleSheet';

// Redux Components
import CoverageView from './redux/containers/dashboard/CoverageView';
import InsightsDashboards from './redux/containers/insights/InsightsDashboards';
import InsightsDashboardView from './redux/containers/insights/InsightsDashboardView';
import HallOfHonor from './redux/containers/hall/HallOfHonor';
import Home from './redux/containers/home/Home';
import Layout from './redux/containers/navbar/Layout';
import NewsletterView from './redux/containers/newsletter/NewsletterView';
import PersonalStats from './redux/containers/personalStats/PersonalStats';
import Project from './redux/containers/project/Project';
import Repositories from './redux/containers/repositories/Repositories';
import Services from './redux/containers/services/Services';
import SnackAlert from './redux/containers/SnackAlert';
import Teams from './redux/containers/teams/Teams';
import AdminView from './redux/containers/user/AdminView';
import Profile from './redux/containers/user/Profile';
// Internal Libraries (Sandpack docs) — wired to Redux store
import InternalLibraries from './redux/containers/internalLibraries/InternalLibraries';
// zippedi tools js imports
import { createHeimdalClient } from '@zippeditoolsjs/heimdal-client';
import {
  createHeimdalThunkExtra,
  heimdalReducers,
} from '@zippeditoolsjs/heimdal-react';
import { ReduxLoginWeb as PrivateRoute } from '@zippeditoolsjs/web';

// Services
import createStore from 'core/store';

import DataSource from 'core/services/dataSource';
import HTTPService from 'core/services/http';

const {
  REACT_APP_API_BASE_URL,
  REACT_APP_AUTH_BACKEND_URL,
  REACT_APP_AUTH_BASE_URL,
  REACT_APP_BASE_URL,
} = process.env;

// Fallback URLs for development
const API_BASE_URL = REACT_APP_API_BASE_URL || 'http://localhost:8000/api';
const AUTH_BACKEND_URL = REACT_APP_AUTH_BACKEND_URL || 'http://localhost:8000/auth';

const http = new HTTPService();

const dataSource = new DataSource({
  baseUrl: API_BASE_URL,
  http,
});

const heimdalClient = createHeimdalClient({ baseUrl: AUTH_BACKEND_URL });

// heimdalReducers adds the `heimdalSession` branch the guard reads, and
// createHeimdalThunkExtra hands Heimdal's thunks the client to read it with.
const store = createStore(
  { dataSource },
  {
    reducers: heimdalReducers,
    extraArgument: createHeimdalThunkExtra(heimdalClient),
  },
);

const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <SnackAlert />
        <PrivateRoute
          appUrlLogin={REACT_APP_AUTH_BASE_URL}
          appBaseUrl={REACT_APP_BASE_URL}>
          <Router>
            <Layout>
              <Routes>
                <Route path="/projects" element={<Home />} />
                <Route path="/adminView" element={<AdminView />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/project/:id" element={<Project />} />
                <Route path="/" element={<NewsletterView />} />
                <Route path="/newsletter" element={<NewsletterView />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/coverage" element={<CoverageView />} />
                <Route path="/personal_stats" element={<PersonalStats />} />
                <Route path='/repositories' element={<Repositories />} />
                <Route path='/services' element={<Services />} />
                <Route path="/hall-of-honor" element={<HallOfHonor />} />
                <Route path="/insights" element={<InsightsDashboards />} />
                <Route path="/insights/dashboards/:id" element={<InsightsDashboardView />} />
                <Route path="/internal-libraries" element={<InternalLibraries />} />
              </Routes>
            </Layout>
          </Router>
        </PrivateRoute>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
